"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickBoxIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("./withSVGIcon");
var Icon = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "0.833333", stroke: "black", strokeWidth: strokeWidth }, void 0),
            jsx_runtime_1.jsx("path", { d: "M4 7.41777L6.99976 10.4175L11.9993 4.91797", stroke: "black", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }, void 0));
};
exports.TickBoxIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 16 16' });
//# sourceMappingURL=TickBoxIcon.js.map